import { useState, useEffect } from 'react'
import ErrorStackParser from 'error-stack-parser'
import StackTraceGPS from 'stacktrace-gps'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/error'

const gps = new StackTraceGPS()


const Error = ({ error }) => {

  const frames = ErrorStackParser.parse(error)
  const [mapped, setMapped] = useState(frames)

  useEffect(() => {
    Promise.all(frames.map(f => gps.pinpoint(f).catch(() => f)))
      .then(setMapped)
  }, [error])


  return (
    <PageWrapper title="Error Trap" HelpText={HelpText} isErrorPage={true}>
      <div className='p-10 overflow-y-scroll flex flex-col h-full'>
        <h2>Error</h2>
        <b>{error.message}</b>

        <h2>Stack</h2>
        {mapped.map((f, i) => (
          <div key={i}>{f.fileName} | {f.functionName} | {f.lineNumber}:{f.columnNumber}</div>
        ))}
      </div>
    </PageWrapper>
  )
}

export default Error